exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#list-comment[data-v-7174881e]{margin-bottom:20px}#total-comment[data-v-7174881e]{border-top:1px solid #ccc;margin-top:30px;padding-top:30px}#comment[data-v-7174881e]{padding:10px;background-color:#f0f8ff;font-size:12px;font-family:Andale Mono,Lucida Console,Courier New,\"monospace\"}#comment-name[data-v-7174881e]{margin-bottom:5px}#message[data-v-7174881e]{border:1px solid #cccddd;background-color:#5dfccc;padding:10px}", ""]);

// exports
